<template>
    <div :class="containerClass" @click="onWrapperClick">
        <AppTopBar @menu-toggle="onMenuToggle" v-if="!outsideRoute"  v-show="isSidebarVisible()" />

        <transition name="layout-sidebar" v-if="!outsideRoute">
            <aside :class="sidebarClass" @click="onSidebarClick" v-show="isSidebarVisible()">
                <div class="layout-logo">
                    <router-link v-if="$store.state.currentUser.role == 'user'" to="/user/overview">
                        <!-- <img src="assets/layout/images/site-logo-WN.svg" alt="Wealth Net" /> -->
                        <img class="app-logo" src="assets/layout/images/logo.png" alt="MC Bot">

                    </router-link>
                    <router-link v-if="$store.state.currentUser.role == 'admin'" to="/admin">
                        <img class="app-logo" src="assets/layout/images/logo.png" alt="MC Bot">
                        <!-- <img src="assets/layout/images/site-logo-WN.svg" alt="Wealth Net" /> -->

                    </router-link>
                </div>

                <AppProfile />
                <AppMenu :model="menu" @menuitem-click="onMenuItemClick" />
            </aside>
        </transition>

        <main class="layout-main layout-main-full" v-if="outsideRoute">
            <router-view />
        </main>

        <main class="layout-main" v-if="!outsideRoute">
            <router-view />
        </main>

        <Dialog header="Error" :visible.sync="errorDialog" :style="{width: '30vw'}" :modal="true" :closable="false">
            <span>{{ errorDialogMsg }}</span>
            <template #footer>
                <Button label="Close" @click="close()" icon="pi pi-times" class="p-button" />
            </template>
        </Dialog>


        <AppFooter v-if="!outsideRoute" />
    </div>
</template>

<script>
    import AppTopBar from './AppTopbar.vue';
    import AppProfile from './AppProfile.vue';
    import AppMenu from './AppMenu.vue';
    import AppFooter from './AppFooter.vue';

    export default {
        data() {

            return {
                layoutMode: 'static',
                layoutColorMode: 'dark',
                staticMenuInactive: false,
                overlayMenuActive: false,
                mobileMenuActive: false,
                outsideRoute: 1,
            }
        },
        watch: {
            $route() {
                this.menuActive = false;
                this.$toast.removeAllGroups();
                if (this.$route.meta == 'login' || this.$route.meta == 'register') this.outsideRoute = 1
                else this.outsideRoute = 0
            }
        },
        methods: {
            onWrapperClick() {
                if (!this.menuClick) {
                    this.overlayMenuActive = false;
                    this.mobileMenuActive = false;
                }

                this.menuClick = false;
            },
            onMenuToggle() {
                this.menuClick = true;

                if (this.isDesktop()) {
                    if (this.layoutMode === 'overlay') {
                        this.overlayMenuActive = !this.overlayMenuActive;
                    }
                    else if (this.layoutMode === 'static') {
                        this.staticMenuInactive = !this.staticMenuInactive;
                    }
                }
                else {
                    this.mobileMenuActive = !this.mobileMenuActive;
                }

                event.preventDefault();
            },
            onSidebarClick() {
                this.menuClick = true;
            },
            onMenuItemClick(event) {
                if (event.item && !event.item.items) {
                    this.overlayMenuActive = false;
                    this.mobileMenuActive = false;
                }
            },
            addClass(element, className) {
                if (element.classList)
                    element.classList.add(className);
                else
                    element.className += ' ' + className;
            },
            removeClass(element, className) {
                if (element.classList)
                    element.classList.remove(className);
                else
                    element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
            },
            isDesktop() {
                return window.innerWidth > 1024;
            },
            isSidebarVisible() {
                if (this.isDesktop()) {
                    if (this.layoutMode === 'static')
                        return !this.staticMenuInactive;
                    else if (this.layoutMode === 'overlay')
                        return this.overlayMenuActive;
                    else
                        return true;
                }
                else {
                    console.log("mob je");
                    this.layoutMode = 'overlay';
                    this.mobileMenuActive = true;
                    this.staticMenuInactive = true;
                    return false;

                    //bilo return true (ostalo ja dodao)
                }
            },
            close() {
                this.$store.commit('closeErrorDialog')
            },
            closeDialog() {
                this.$store.commit('closeDialog')
            },
            redirectToProfile() {
                this.$store.commit('closeDialog')
                this.$router.push('/user/profile')
            },
            redirectToFinancial() {
                this.$store.commit('closeDialog')
                this.$router.push('/user/financial')
            },

        },
        computed: {
            menu() {
                if (['admin', 'user'].includes(this.$route.meta) === true) {
                    if (this.$store.state.currentUser.role == 'admin') {
                        return [
                            { label: 'Overview', icon: 'icon-menu', to: '/admin' },
                            //tempmcanadi
                            { label: 'User Overview', icon: 'icon-report-1', to: '/user/overview' },

                            { label: 'Member List', icon: 'icon-user-news-1', to: '/admin/members' },
                            //{
                            //    label: 'Reports', icon: 'icon-report',
                            //    items: [
                            //        { label: 'Purchases', to: '/admin/reports/purchases' },
                            //        { label: 'BTC Purchases', to: '/admin/reports/btcpurchases' },
                            //        { label: 'BTC Transactions', to: '/admin/reports/btctransactions' },
                            //        { label: 'Invoices', to: '/admin/reports/invoices' },
                            //        { label: 'Turnover', to: '/admin/reports/turnover' },
                            //    ]
                            //},


                            { label: 'News', icon: 'icon-news', to: '/admin/news' },

                            //{ label: 'Store', icon: 'icon-shop', to: '/user/shop' },
                            //{ label: 'My Purchases', icon: 'icon-bill', to: '/user/purchases' },

                            //{ label: 'Commissions', icon: 'icon-money', to: '/admin/commissions' },
                            //tempmcanadi
                            { label: 'User News', icon: 'icon-user-news', to: '/user/news/0' },
                            { label: 'Account summary', icon: 'icon-user-news', to: '/user/accountsummary' },
                            { label: 'Store', icon: 'icon-shop', to: '/user/shop' },
                            //{ label: 'Payouts', icon: 'icon-deposit', to: '/admin/payouts' },
                            //{
                            //    label: 'Settings', icon: 'icon-settings',
                            //    items: [
                            //        { label: 'Direct Levels', to: '/admin/settings/levels' },
                            //        { label: 'Packages', to: '/admin/settings/packages' },
                            //        { label: 'Calculate incentives', to: '/admin/settings/calculateincentives' }
                            //    ]
                            //},
                            //{ label: 'Vouchers', icon: 'icon-ticket', to: '/admin/voucher' },
                            //{
                            //    label: 'Document Area', icon: 'icon-document',
                            //    items: [
                            //        { label: 'General', to: '/admin/documents/general' },
                            //        { label: 'Products', to: '/admin/documents/products' },
                            //        { label: 'Video', to: '/admin/documents/video' },
                            //        { label: 'Legal', to: '/admin/documents/legal' },
                            //        { label: 'Whitepaper', to: '/admin/documents/whitepaper' },
                            //        { label: 'Picture', to: '/admin/documents/picture' },
                            //        { label: 'Banner', to: '/admin/documents/banner' },
                            //    ]
                            //},
                        ]
                    }
                    else {
                        let menu = [

                        ]
                        if (process.env.VUE_APP_ENV == 'development') {
                            menu.push(
                                { label: 'Overview', icon: 'icon-menu', to: '/user/overview' },

                                { label: 'News', icon: 'icon-news', to: '/user/news/0' },
                                { label: 'Account summary', icon: 'icon-user-news', to: '/user/accountsummary' },

                                //{ label: 'Store', icon: 'icon-shop', to: '/user/shop' },
                                //{ label: 'My Purchases', icon: 'icon-bill', to: '/user/purchases' },
                                //{ label: 'Commissions', icon: 'icon-money', to: '/user/commissions' },
                                //{ label: 'Payouts', icon: 'icon-deposit', to: '/user/payouts' },
                            )
                        }
                        if (process.env.VUE_APP_ENV == 'production') {
                            menu.push(
                                { label: 'Overview', icon: 'icon-menu', to: '/user/overview' },
                                { label: 'Account summary', icon: 'icon-user-news', to: '/user/accountsummary' },

                                { label: 'News', icon: 'icon-news', to: '/user/news/0' },

                                //{ label: 'Store', icon: 'icon-shop', to: '/user/shop' },
                                //{ label: 'My Purchases', icon: 'icon-bill', to: '/user/purchases' },
                                //{ label: 'Commissions', icon: 'icon-money', to: '/user/commissions' },
                                //{ label: 'Payouts', icon: 'icon-deposit', to: '/user/payouts' },
                            )
                        }
                        return menu
                    }
                }
                return []
            },
            containerClass() {
                return ['layout-wrapper', {
                    'layout-overlay': this.layoutMode === 'overlay',
                    'layout-static': this.layoutMode === 'static',
                    'layout-static-sidebar-inactive': this.staticMenuInactive && this.layoutMode === 'static',
                    'layout-overlay-sidebar-active': this.overlayMenuActive && this.layoutMode === 'overlay',
                    'layout-mobile-sidebar-active': this.mobileMenuActive
                }];
            },
            sidebarClass() {
                return ['layout-sidebar', {
                    'layout-sidebar-dark': this.layoutColorMode === 'dark',
                    'layout-sidebar-light': this.layoutColorMode === 'light'
                }];
            },
            logo() {
                return (this.layoutColorMode === 'dark') ? "assets/layout/images/logo-white.svg" : "assets/layout/images/logo.svg";
            },
            errorDialog() {
                return this.$store.state.errorDialog
            },
            errorDialogMsg() {
                return this.$store.state.errorDialogMsg
            },
            dialog() {
                return this.$store.state.dialog
            },
        },
        beforeUpdate() {
            if (this.mobileMenuActive)
                this.addClass(document.body, 'body-overflow-hidden');
            else
                this.removeClass(document.body, 'body-overflow-hidden');
        },
        components: {
            'AppTopBar': AppTopBar,
            'AppProfile': AppProfile,
            'AppMenu': AppMenu,
            'AppFooter': AppFooter,
        }
    }
</script>


<style scoped>
    .app-logo {
        display: block;
        margin-left: auto;
        margin-right: auto;
        width: 50%;
    }
</style>

